import { api, ApiRes } from './client'

export const generatePaymentQrCode = (platform, requestBody): ApiRes<any> =>
    api.post(`platforms/${platform}/payment_qr_code`, requestBody)
